import React from 'react'
import { Dialog } from '@headlessui/react'
import { currencySymbolMapping } from '../../../../../CommonComponent/staticValues'

export default function AuctionRulesModal({ auctionData, isOpen, setIsOpen }) {
    const currencySymbol = currencySymbolMapping[auctionData?.currency] || '$';

    const getRuleValue = (value, fallback = 'Not set') => {
        if (value === undefined || value === null || value === '') return fallback;
        return value;
    };

    return (
        <Dialog open={isOpen} onClose={() => setIsOpen(false)}
            data-te-modal-init
            className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-[#282828cc]"
            id="auctionRulesModal"
            tabIndex="-1"
            aria-labelledby="auctionRulesModalLabel"
            aria-modal="true"
            role="dialog">
            <Dialog.Panel
                data-te-modal-dialog-ref
                className="pointer-events-none mx-5 relative flex min-h-[calc(100%-1rem)] w-auto
                items-center transition-all duration-300 ease-in-out min-[740px]:mx-auto min-[740px]:mt-7 
                min-[740px]:min-h-[calc(100%-3.5rem)] min-[740px]:max-w-[658px]">
                <div
                    className="pointer-events-auto relative flex w-full flex-col rounded-md border-none 
                    bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <Dialog.Title
                        className="flex flex-shrink-0 border-b border-[#A1A1A9] items-center justify-between rounded-t-md p-4">
                        <p className="text-[22px] text-[#343434] leading-normal font-medium pl-3">Auction Rules</p>
                        <button onClick={() => setIsOpen(false)}
                            type="button"
                            className="box-content rounded-none border-none"
                            data-te-modal-dismiss
                            aria-label="Close">
                            <img src="/images/CloseButton-modalcontent.svg" alt="close" />
                        </button>
                    </Dialog.Title>
                    
                    <div className="p-6 max-h-[70vh] overflow-y-auto">
                        {/* Extension Type */}
                        <div className="mb-5">
                            <p className="text-[14px] font-semibold text-[#343434] mb-1">Extension Type</p>
                            <p className="text-[13px] text-[#52525A]">
                                {getRuleValue(auctionData?.extension_type)}
                            </p>
                        </div>

                        {/* Extension Time */}
                        <div className="mb-5">
                            <p className="text-[14px] font-semibold text-[#343434] mb-1">Extension Time</p>
                            <p className="text-[13px] text-[#52525A]">
                                {auctionData?.extension_time ? `${auctionData.extension_time} minute(s)` : 'Not set'}
                            </p>
                        </div>

                        {/* Extension Time Between Lots (if applicable) */}
                        {(auctionData?.extension_type === 'Cascade' || auctionData?.extension_type === 'Individual lots') && (
                            <div className="mb-5">
                                <p className="text-[14px] font-semibold text-[#343434] mb-1">Time Between Lots</p>
                                <p className="text-[13px] text-[#52525A]">
                                    {auctionData?.extension_time_between_lots 
                                        ? `${auctionData.extension_time_between_lots} second(s)` 
                                        : 'Not set'}
                                </p>
                            </div>
                        )}

                        {/* Registration Type */}
                        <div className="mb-5">
                            <p className="text-[14px] font-semibold text-[#343434] mb-1">Registration Type</p>
                            <p className="text-[13px] text-[#52525A]">
                                {getRuleValue(auctionData?.registration_type)}
                            </p>
                        </div>

                        {/* Buyer Fees */}
                        <div className="mb-5">
                            <p className="text-[14px] font-semibold text-[#343434] mb-1">Buyer Fees</p>
                            <p className="text-[13px] text-[#52525A]">
                                {auctionData?.add_buyer_fees === 'percentage' && auctionData?.percentage
                                    ? `${auctionData.percentage}%`
                                    : auctionData?.add_buyer_fees === 'fixed' && auctionData?.fees
                                        ? `${currencySymbol}${auctionData.fees}`
                                        : auctionData?.add_buyer_fees === 'no_buyer_fee' 
                                            ? 'No buyer fee'
                                            : 'Not set'}
                            </p>
                        </div>

                        {/* Currency */}
                        <div className="mb-5">
                            <p className="text-[14px] font-semibold text-[#343434] mb-1">Currency</p>
                            <p className="text-[13px] text-[#52525A]">
                                {getRuleValue(auctionData?.currency)} ({currencySymbol})
                            </p>
                        </div>

                        {/* Bidding History */}
                        <div className="mb-5">
                            <p className="text-[14px] font-semibold text-[#343434] mb-1">Bidding History</p>
                            <p className="text-[13px] text-[#52525A]">
                                {auctionData?.show_bidding_history ? 'Visible' : 'Hidden'}
                            </p>
                        </div>

                        {/* Publish Auction Results */}
                        <div className="mb-2">
                            <p className="text-[14px] font-semibold text-[#343434] mb-1">Publish Auction Results</p>
                            <p className="text-[13px] text-[#52525A]">
                                {auctionData?.publish_auction_results ? 'Yes' : 'No'}
                            </p>
                        </div>
                    </div>

                    <div className="flex justify-end border-t border-[#A1A1A9] p-4">
                        <button
                            onClick={() => setIsOpen(false)}
                            className="px-[31px] py-[10px] bg-[#282828] text-white text-[14px] 
                                font-medium rounded-[6px] hover:bg-[#3F3F45] transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </Dialog.Panel>
        </Dialog>
    )
}
